// Content container, port of the Next.js app's src/app/venue/venue-shell.tsx.
// Provides the page padding + max-width the ported pages assume. Admin pages
// get a dashboard-width container at lg+; member pages stay mobile-app width
// at all sizes. Without this, ported pages (which use bare `space-y-6`) sit
// flush against the viewport edges.
import type { ReactNode } from "react";
import { useRouterState } from "@tanstack/react-router";

export function VenueShell({ children }: { children: ReactNode }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isAdmin = pathname === "/admin" || pathname.startsWith("/admin/");
  // Admin (a management UI) stays comfortably inset. Member pages honour the
  // venue's density control via --app-pad (inset = 1rem, full-bleed = 0).
  return (
    <div
      className={`mx-auto pb-24 pt-6 lg:pb-12 ${
        isAdmin
          ? // Phone: centred app width (looks great as-is). Desktop: FULL BLEED,
            // the admin sidebar pins to the far-left viewport edge and the
            // content (e.g. the website builder) uses all the real estate.
            // Gutters are owned by AdminLayout, not this shell.
            "max-w-lg px-4 lg:mx-0 lg:max-w-none lg:px-0"
          : "max-w-lg px-[var(--app-pad,1rem)]"
      }`}
    >
      {children}
    </div>
  );
}
